import React from "react";

type LegendItem =
  | { label: string; icon: string; color: string; node?: never }
  | { label: string; node: React.ReactNode; icon?: never; color?: never };

const LEGEND_ITEMS: LegendItem[] = [
  { label: "Present", icon: "ri-checkbox-circle-fill", color: "text-success" },
  { label: "Half Day", icon: "ri-checkbox-circle-line", color: "text-success" },
  { label: "Absent", icon: "ri-close-circle-fill", color: "text-danger" },
  { label: "On Leave", icon: "ri-door-open-line", color: "text-primary" },
  {
    label: "Half Day Leave",
    node: (
      <span className="position-relative d-inline-flex">
        <i className="ri-door-open-line text-primary" style={{ fontSize: "1rem" }} />
        <span
          className="position-absolute bg-info rounded-circle d-flex align-items-center justify-content-center text-white fw-bold"
          style={{ width: 10, height: 10, fontSize: 6, top: -1, right: -4, lineHeight: 1 }}
        >½</span>
      </span>
    ),
  },
  { label: "Holiday", icon: "ri-star-s-fill", color: "text-warning" },
];

const AttendanceLegend = () => (
  <div className="d-flex flex-wrap align-items-center gap-3 gap-xl-4 py-2 mb-2">
    <span className="text-muted small fw-medium me-1">Legend:</span>
    {LEGEND_ITEMS.map(({ label, ...rest }) => (
      <span
        key={label}
        className="d-inline-flex align-items-center gap-1 small text-muted"
      >
        {"node" in rest && rest.node ? (
          rest.node
        ) : (
          <i className={`${"icon" in rest ? rest.icon : ""} ${"color" in rest ? rest.color : ""}`} style={{ fontSize: "1rem" }} />
        )}
        <span>{label}</span>
      </span>
    ))}
    <span className="d-inline-flex align-items-center gap-1 small text-muted">
      <i
        className="ri-add-circle-line text-muted"
        style={{ fontSize: "1rem" }}
      />
      <span>Pending</span>
    </span>
  </div>
);

export default AttendanceLegend;
